import { noop } from '../app/utils/utils';

export const UAParser = noop;

export default {
    UAParser,
};
